

// import { getLinkForModule } from '../../src/atoms/ComponentBox/config/moduleRoutes';

// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { dataRetrivewApi, updateWishlistApi } from '../Api/Userpermission/Api';

// export const fetchUserPermissions = createAsyncThunk(
//   'permissions/fetchUserPermissions',
//   async (userId) => {
//     try {
//       const payload = {
//         Start: 0,
//         PageSizea: 0,
//         SearchText: userId
//       };
//       const response = await dataRetrivewApi(payload);
//       return response.data.Data;
//     } catch (error) {
//       throw error;
//     }
//   }
// );

// export const updateWishlist = createAsyncThunk(
//   'permissions/updateWishlist',
//   async ({ UserPrevId, wishlist }, { rejectWithValue }) => {
//     try {
//       const payload = {
//         UserPrevId,
//         wishlist
//       };
//       const response = await updateWishlistApi(payload);
//       return { UserPrevId, wishlist, response: response.data };
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );



// const permissionsSlice = createSlice({
//   name: 'permissions',
//   initialState: {
//     data: [],
//     status: 'idle',
//     error: null,
//     currentModule: null,
//     favorites: [],
//     wishlistStatus: 'idle'
//   },
//   reducers: {
//     setCurrentModule: (state, action) => {
//       state.currentModule = action.payload;
//     },
//     updateFavoriteLocally: (state, action) => {
//       const { UserPrevId, wishlist } = action.payload;
//       const itemIndex = state.data.findIndex(item => item.UserPrevId === UserPrevId);
      
//       if (itemIndex !== -1) {
//         state.data[itemIndex].wishlist = wishlist;
//       }
      
//       if (wishlist) {
//         if (!state.favorites.some(item => item.UserPrevId === UserPrevId)) {
//           const favoriteItem = state.data.find(item => item.UserPrevId === UserPrevId);
//           if (favoriteItem) {
//             state.favorites.push({
//               ...favoriteItem,
//               link: getLinkForModule(favoriteItem.ModuleName)
//             });
//           }
//         }
//       } else {
//         state.favorites = state.favorites.filter(item => item.UserPrevId !== UserPrevId);
//       }
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchUserPermissions.pending, (state) => {
//         state.status = 'loading';
//       })
//       .addCase(fetchUserPermissions.fulfilled, (state, action) => {
//         state.status = 'succeeded';
//         state.data = action.payload;
//         state.favorites = action.payload
//           .filter(item => item.wishlist)
//           .map(item => ({
//             ...item,
//             link: getLinkForModule(item.ModuleName)
//           }));
//       })
//       .addCase(fetchUserPermissions.rejected, (state, action) => {
//         state.status = 'failed';
//         state.error = action.error.message;
//       })
//       .addCase(updateWishlist.pending, (state) => {
//         state.wishlistStatus = 'loading';
//       })
//       .addCase(updateWishlist.fulfilled, (state, action) => {
//         state.wishlistStatus = 'succeeded';
//         const { UserPrevId, wishlist } = action.payload;
//         const itemIndex = state.data.findIndex(item => item.UserPrevId === UserPrevId);
        
//         if (itemIndex !== -1) {
//           state.data[itemIndex].wishlist = wishlist;
//         }
        
//         if (wishlist) {
//           if (!state.favorites.some(item => item.UserPrevId === UserPrevId)) {
//             const favoriteItem = state.data.find(item => item.UserPrevId === UserPrevId);
//             if (favoriteItem) {
//               state.favorites.push({
//                 ...favoriteItem,
//                 link: getLinkForModule(favoriteItem.ModuleName)
//               });
//             }
//           }
//         } else {
//           state.favorites = state.favorites.filter(item => item.UserPrevId !== UserPrevId);
//         }
//       })
//       .addCase(updateWishlist.rejected, (state, action) => {
//         state.wishlistStatus = 'failed';
//         if (action.meta && action.meta.arg) {
//           const { UserPrevId, wishlist } = action.meta.arg;
//           const itemIndex = state.data.findIndex(item => item.UserPrevId === UserPrevId);
//           if (itemIndex !== -1) {
//             state.data[itemIndex].wishlist = !wishlist;
//           }
//         }
//       });
//   },
// });

// // Export actions
// export const { setCurrentModule, updateFavoriteLocally } = permissionsSlice.actions;

// // Export selectors
// export const selectPermissions = (state) => state.permissions.data;
// export const selectCurrentModulePermissions = (state) => {
//   const currentModule = state.permissions.currentModule;
//   return state.permissions.data.find(p => p.ModuleName === currentModule) || {
//     AddRec: "0",
//     EditRec: "0",
//     DeleteRec: "0",
//     ViewRec: "0"
//   };
// };
// export const selectFavorites = (state) => state.permissions.favorites;
// export const selectWishlistStatus = (state) => state.permissions.wishlistStatus;

// export default permissionsSlice.reducer;







import { getLinkForModule } from '../../src/atoms/ComponentBox/config/moduleRoutes';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dataRetrivewApi, updateWishlistApi } from '../Api/Userpermission/Api';

export const fetchUserPermissions = createAsyncThunk(
  'permissions/fetchUserPermissions',
  async (userId) => {
    try {
      const payload = {
        Start: 0,
        PageSizea: 0,
        SearchText: userId
      };
      const response = await dataRetrivewApi(payload);
      return response.data.Data;
    } catch (error) {
      throw error;
    }
  }
);

export const updateWishlist = createAsyncThunk(
  'permissions/updateWishlist',
  async ({ UserPrevId, wishlist }, { rejectWithValue }) => {
    try {
      const payload = {
        UserPrevId,
        wishlist
      };
      const response = await updateWishlistApi(payload);
      return { UserPrevId, wishlist, response: response.data };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState: {
    data: [],
    status: 'idle',
    error: null,
    favorites: [],
    wishlistStatus: 'idle'
  },
  reducers: {
    updateFavoriteLocally: (state, action) => {
      const { UserPrevId, wishlist } = action.payload;
      const itemIndex = state.data.findIndex(item => item.UserPrevId === UserPrevId);
      
      if (itemIndex !== -1) {
        state.data[itemIndex].wishlist = wishlist;
      }
      
      if (wishlist) {
        if (!state.favorites.some(item => item.UserPrevId === UserPrevId)) {
          const favoriteItem = state.data.find(item => item.UserPrevId === UserPrevId);
          if (favoriteItem) {
            state.favorites.push({
              ...favoriteItem,
              link: getLinkForModule(favoriteItem.ModuleName)
            });
          }
        }
      } else {
        state.favorites = state.favorites.filter(item => item.UserPrevId !== UserPrevId);
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPermissions.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchUserPermissions.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.favorites = action.payload
          .filter(item => item.wishlist)
          .map(item => ({
            ...item,
            link: getLinkForModule(item.ModuleName)
          }));
      })
      .addCase(fetchUserPermissions.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(updateWishlist.pending, (state) => {
        state.wishlistStatus = 'loading';
      })
      .addCase(updateWishlist.fulfilled, (state, action) => {
        state.wishlistStatus = 'succeeded';
        const { UserPrevId, wishlist } = action.payload;
        const itemIndex = state.data.findIndex(item => item.UserPrevId === UserPrevId);
        
        if (itemIndex !== -1) {
          state.data[itemIndex].wishlist = wishlist;
        }
        
        if (wishlist) {
          if (!state.favorites.some(item => item.UserPrevId === UserPrevId)) {
            const favoriteItem = state.data.find(item => item.UserPrevId === UserPrevId);
            if (favoriteItem) {
              state.favorites.push({
                ...favoriteItem,
                link: getLinkForModule(favoriteItem.ModuleName)
              });
            }
          }
        } else {
          state.favorites = state.favorites.filter(item => item.UserPrevId !== UserPrevId);
        }
      })
      .addCase(updateWishlist.rejected, (state, action) => {
        state.wishlistStatus = 'failed';
        if (action.meta && action.meta.arg) {
          const { UserPrevId, wishlist } = action.meta.arg;
          const itemIndex = state.data.findIndex(item => item.UserPrevId === UserPrevId);
          if (itemIndex !== -1) {
            state.data[itemIndex].wishlist = !wishlist;
          }
        }
      });
  },
});

// Export actions
export const { updateFavoriteLocally } = permissionsSlice.actions;

// Export selectors
export const selectPermissions = (state) => state.permissions.data;
export const selectPermissionsByModule = (state, moduleName) => {
  return state.permissions.data.find(p => p.ModuleName === moduleName) || {
    AddRec: "0",
    EditRec: "0",
    DeleteRec: "0",
    ViewRec: "0",
    ReportRec: "0",
    AllRec: "0"
  };
};
export const selectFavorites = (state) => state.permissions.favorites;
export const selectWishlistStatus = (state) => state.permissions.wishlistStatus;
export const selectPermissionsStatus = (state) => state.permissions.status;

export default permissionsSlice.reducer;